import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Backdrop } from '@mui/material';
import { useAuth } from '../../../context/auth-context';
import { UserDropdown } from '../../UserDropdown/UserDropdown';
import { useSiteConfig } from '../../../context/site-configs-context';
import { getEnvironmentVariable } from '../../../utils';
import './TopMenuSkin1.scss';

const platformURL = getEnvironmentVariable('REACT_APP_PLATFORM_URL');
const LOGIN_URL = `${platformURL}/login`;
const REGISTRATION_URL = `${platformURL}/register`;

interface ExternalLink {
    name: string;
    value: string;
    show: boolean;
}

interface Props {
    externalLinks?: ExternalLink[];
}

const TopMenuSkin1: React.FC<Props> = ({
    externalLinks = [],
}) => {
    const {
        isAuthLoading,
        isAuthenticated,
        userInfo,
        logout,
        goToPlatform,
    } = useAuth();

    const navigate = useNavigate();
    const { logo } = useSiteConfig();
    const [ mobileNavActive, setMobileNavActive ] = useState(false);

    const toggleMobileNav = () => {
        setMobileNavActive(!mobileNavActive);
    };

    if (isAuthLoading) {
        return null;
    }

    const loginUrl = `${LOGIN_URL}?callback=${window.location.href}`;

    return (
        <>
            <header className="topmenu-skin1">
                <div
                    className="topmenu-skin1__logo"
                    onClick={() => navigate('/')}
                >
                    <img src={logo} alt="logo"/>
                </div>

                <nav
                    className={`topmenu-skin1__nav ${
                        mobileNavActive ? 'active' : ''
                    }`}
                >
                    {externalLinks
                    .filter((link) => link.show)
                    .map((link, index) => (
                        <a
                            key={index}
                            href={link.value}
                            className="topmenu-skin1__link"
                            target="_blank"
                            rel="noreferrer"
                        >
                            {link.name}
                        </a>
                    ))}

                    <div className="topmenu-skin1__buttons">
                        {isAuthenticated && userInfo ? (
                            <UserDropdown
                                username={userInfo.username}
                                onLogout={logout}
                                onGoToPlatform={goToPlatform}
                            />
                        ) : (
                            <>
                                <Link
                                    className="topmenu-skin1__button topmenu-skin1__button--signup"
                                    to={REGISTRATION_URL}
                                >
                                    Register
                                </Link>
                                <Link
                                    className="topmenu-skin1__button topmenu-skin1__button--login"
                                    to={loginUrl}
                                >
                                    Login
                                </Link>
                            </>
                        )}
                    </div>
                </nav>

                <div
                    className="topmenu-skin1__menu-icon"
                    onClick={toggleMobileNav}
                >
                    {mobileNavActive ? <>&times;</> : <>&#9776;</>}
                </div>
            </header>

            <Backdrop
                open={mobileNavActive}
                onClick={() => setMobileNavActive(false)}
            />
        </>
    );
};

export default TopMenuSkin1;